import { useDispatch, useSelector } from "react-redux"
import { setHintProgressFlag } from "../state/index.js"
import api from "../api.js"
import { useCallback } from "react"

export const useHintProgress = () => {
    const dispatch = useDispatch()
    const hintProgress = useSelector(state => state.hintProgress)

    const setHintProgress = useCallback(async (key, value = true) => {
        const previousValue = hintProgress[key]
        dispatch(setHintProgressFlag({ key, value }))
        try {
            await api.patch('/auth/hints-progress', { key, value })
        } catch (error) {
            dispatch(setHintProgressFlag({ key, value: previousValue }))
        }
    }, [dispatch, hintProgress])

    return { setHintProgress }
}